import type { RootState } from "~/redux/store";
import type { AnyAction } from "~/redux/types";
import type { ThunkAction } from "redux-thunk";
import type { ProductData } from "~/models/ProductData";
import { fetchFccRecommendedProducts } from "~/ProductDetails/api/fetchFccRecommendedProducts";

type ThunkResult<R> = ThunkAction<R, RootState, undefined, AnyAction>;

export type FCCRecommendedProductsActions = ReturnType<
  typeof startFetchFccRecommendedProducts | typeof finishFetchFccRecommendedProducts
>;

export const START_FETCH_FCC_RECOMMENDED_PRODUCTS = "Start Fetch FCC recommended products";
export const FINISH_FETCH_FCC_RECOMMENDED_PRODUCTS = "Finish Fetch FCC recommended products";

export const startFetchFccRecommendedProducts = () => {
  return { type: START_FETCH_FCC_RECOMMENDED_PRODUCTS } as const;
};

export const finishFetchFccRecommendedProducts = (fccRecommendedProducts: ProductData[], error: boolean) => {
  return { type: FINISH_FETCH_FCC_RECOMMENDED_PRODUCTS, payload: { fccRecommendedProducts, error } } as const;
};

export const fetchFccRecommendedProductsThunk = (): ThunkResult<void> => {
  return async (dispatch) => {
    dispatch(startFetchFccRecommendedProducts());
    try {
      const fccRecommendedProducts = await fetchFccRecommendedProducts();
      dispatch(finishFetchFccRecommendedProducts(fccRecommendedProducts, false));
    } catch (error) {
      console.error(error);
      dispatch(finishFetchFccRecommendedProducts([], true));
    }
  };
};
